module.exports = __webpack_public_path__ + "img/skypets-4.6aad1d2a.jpg";